/* ============================================================
   lf-card.js
   Add ONCE before </body> in theme.liquid:
   <script src="{{ 'lf-card.js' | asset_url }}" defer></script>
   ============================================================ */

(function () {

  /* ── Wishlist helpers ────────────────────────────────── */
  function getList() {
    try { return JSON.parse(localStorage.getItem('lf_wishlist') || '[]'); }
    catch (e) { return []; }
  }
  function saveList(arr) {
    try { localStorage.setItem('lf_wishlist', JSON.stringify(arr)); }
    catch (e) {}
  }

  function setButtonState(btn, wished) {
    btn.innerHTML = wished ? '&#9829;' : '&#9825;';
    btn.classList.toggle('wished', wished);
    btn.setAttribute('aria-pressed', String(wished));
  }

  function initWishButtons() {
    var saved = getList();
    document.querySelectorAll('.lf-related-card__wish').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';

      var id = btn.dataset.productId;
      setButtonState(btn, saved.indexOf(id) > -1);

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var list   = getList();
        var idx    = list.indexOf(id);
        var wished = idx === -1;
        if (wished) { list.push(id); } else { list.splice(idx, 1); }
        saveList(list);
        /* Update ALL buttons for this product on the page */
        document.querySelectorAll('.lf-related-card__wish[data-product-id="' + id + '"]')
          .forEach(function (b) { setButtonState(b, wished); });
      });
    });
  }

  /* ── Run on DOM ready ────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishButtons);
  } else {
    initWishButtons();
  }

  /* ── Re-run when new cards appear (AJAX filters etc.) ── */
  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function (mutations) {
      var hasNewCards = mutations.some(function (m) {
        return Array.from(m.addedNodes).some(function (n) {
          return n.nodeType === 1 && (
            n.classList.contains('lf-related-card') ||
            n.querySelector && n.querySelector('.lf-related-card')
          );
        });
      });
      if (hasNewCards) initWishButtons();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

})();
